import React from 'react'
import PropTypes from 'prop-types'
import ChevronDownIcon from '../icons/ChevronDownIcon'

const WRAPPER_CLASS = 'tw:rounded! tw:border tw:border-solid tw:border-gray-300 tw:overflow-hidden'
const BUTTON_BASE_CLASS = 'tw:w-full tw:flex tw:items-center tw:gap-2 tw:px-2.5 tw:py-2.5 '
  + 'tw:border-0 tw:cursor-pointer tw:text-left tw:text-sm tw:text-gray-900'
const BUTTON_OPEN_CLASS = 'tw:bg-gray-100'
const BUTTON_CLOSED_CLASS = 'tw:bg-white'
const TITLE_CLASS = 'tw:flex-1 tw:min-w-0 tw:truncate'
const TITLE_OPEN_CLASS = 'tw:font-medium'
const TITLE_CLOSED_CLASS = 'tw:font-normal'
const CHEVRON_CLASS = 'tw:size-5 tw:shrink-0'
const CHEVRON_ROTATED_CLASS = 'tw:rotate-180'
const CHEVRON_OPEN_CLASS = 'tw:text-gray-900'
const CHEVRON_CLOSED_CLASS = 'tw:text-gray-600'
const BODY_CLASS = 'tw:p-2 tw:bg-white'

const Accordion = ({ title, isOpen, onToggle, headerRight = null, children }) => (
  <div className={WRAPPER_CLASS}>
    <button
      aria-expanded={isOpen}
      className={`${BUTTON_BASE_CLASS} ${isOpen ? BUTTON_OPEN_CLASS : BUTTON_CLOSED_CLASS}`}
      type="button"
      onClick={onToggle}
    >
      <span className={`${TITLE_CLASS} ${isOpen ? TITLE_OPEN_CLASS : TITLE_CLOSED_CLASS}`}>{title}</span>
      {headerRight}
      <ChevronDownIcon
        className={`${CHEVRON_CLASS} ${isOpen ? CHEVRON_OPEN_CLASS : CHEVRON_CLOSED_CLASS} `
          + `${isOpen ? CHEVRON_ROTATED_CLASS : ''}`}
      />
    </button>
    {isOpen ? <div className={BODY_CLASS}>{children}</div> : null}
  </div>
)

Accordion.propTypes = {
  children: PropTypes.node.isRequired,
  headerRight: PropTypes.node,
  isOpen: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired
}

Accordion.defaultProps = {
  headerRight: null
}

export default Accordion
